'use client';
import * as React from 'react';
import { useCustomStyleHook_unstable } from '@fluentui/react-shared-contexts';
import { useMessageBarGroup_unstable } from './useMessageBarGroup';
import { renderMessageBarGroup_unstable } from './renderMessageBarGroup';
import { useMessageBarGroupStyles_unstable } from './useMessageBarGroupStyles.styles';
/**
 * MessageBarGroup component
 */ export const MessageBarGroup = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useMessageBarGroup_unstable(props, ref);
    useMessageBarGroupStyles_unstable(state);
    useCustomStyleHook_unstable('useMessageBarGroupStyles_unstable')(state);
    return renderMessageBarGroup_unstable(state);
});
MessageBarGroup.displayName = 'MessageBarGroup';
